// extracted by css-extract-rspack-plugin
export default {"nbAutocomplete":"nbAutocomplete-_quycJ","nbAutocompleteIsSmall":"nbAutocompleteIsSmall-s5ZdIw"};